import Minipost from "../components/global/minipost";
import Add from "../components/global/ad";
import Headerr from "../components/home/header";
import { Link } from "react-router-dom";
import Chart from "../components/global/chart";
import { db } from "../firebase";
import { useState, useEffect } from "react";

const Home = () => {
  const [newBlogs, setNewBlogs] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/posts");
    ref
      .orderBy("createdate", "desc")
      .limit(3)
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          var storedDate = new Date(doc.data().createdate.toDate());
          var nowDate = new Date();
          var elapsedTime = nowDate.getTime() - storedDate.getTime();
          documents.push({ ...doc.data(), id: doc.id, timeAgo: elapsedTime });
        });
        setNewBlogs(documents);
      });
  }, []);

  
  const [latestCharts, setLatestCharts] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/Charts");
    ref
      .orderBy("createdate", "desc")
      .limit(3)
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id});
        });
        setLatestCharts(documents);
      });
  }, []);
  const [fan, setFan] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/posts");
    ref
      .orderBy("createdate", "desc")
      .where("categories", "array-contains", "KdZTrBbOOSsYjIUGT840")
      .limit(3)
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          var storedDate = new Date(doc.data().createdate.toDate());
          var nowDate = new Date();
          var elapsedTime = nowDate.getTime() - storedDate.getTime();
          documents.push({ ...doc.data(), id: doc.id, timeAgo: elapsedTime });
        });
        setFan(documents);
      });
  }, []);
  
  return (
    <main>
      <Headerr />
      <div className="posts-row">
        <div className="container">
          <h1>مقالات جديدة</h1>
          <div className="wrap">
            <Minipost blogs={newBlogs} />
          </div>
        </div>
      </div>
      <Add />
      <div className="charts">
        <div className="container">
          <div className="head">
            <div className="title">
              <h1>أعلى الترتيبات</h1>
              <h4>في راب سين</h4>
            </div>
            <Link to="/Charts">عرض الكل</Link>
          </div>
          <Chart charts={latestCharts} />
        </div>
      </div>
    </main>
  );
};

export default Home;
